import { useMeasurement } from "lib/@hooks/useMeasurement"
import { Bound } from "lib/@components/binding/Bound"
import { idNotEqual } from "lib/idEquals"
import { TwoSchedules } from "routes/schedule/compare/twoSchedules"
import { Box } from "@mui/material"
import { TaskOrHeader } from "routes/schedule/tasks/taskOrHeader"
import { ComparisonUpdated } from "event-definitions"
import { cloneDeep } from "@apollo/client/utilities"
import { AcceptButton } from "routes/schedule/compare/accept-button"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function MissingTask({ task }) {
    const [{ width, height }, attach] = useMeasurement()
    const { comparisonTarget, target } = useBoundContext()
    const editedTask = target.tasks.find((t) => t.taskId === task.taskId)
    return (
        <Bound acceptId={task.title}>
            <TwoSchedules
                key={task.id}
                copy={copyTask(task)}
                copied={editedTask}
                revert={revertTask(task)}
                showCopy={true}
                leftSchedule={target}
                disabled={!editedTask}
                rightSchedule={comparisonTarget}
                left={
                    <Bound>
                        <Box width={1}>
                            {!editedTask ? (
                                <Box py={1}>
                                    <Box
                                        borderRadius={1}
                                        width={width}
                                        p={1}
                                        height={height}
                                        minHeight={80}
                                        minWidth={180}
                                        textAlign="center"
                                        alignItems="center"
                                        bgcolor="action.selected"
                                        display="flex"
                                        justifyContent="center"
                                    >
                                        Not found in this version
                                    </Box>
                                </Box>
                            ) : (
                                <TaskOrHeader last={true} item={editedTask} />
                            )}
                        </Box>
                    </Bound>
                }
                right={
                    <Bound>
                        <Box ref={attach}>
                            <TaskOrHeader last={true} item={task} />
                        </Box>
                    </Bound>
                }
                after={<AcceptButton id={task.title} />}
            />
        </Bound>
    )

    function copyTask(task) {
        return () => {
            target.tasks.push(cloneDeep(task))
            ComparisonUpdated.raiseOnce()
        }
    }

    function revertTask(task) {
        return () => {
            target.tasks = target.tasks.filter(idNotEqual(task.id))
            ComparisonUpdated.raiseOnce()
        }
    }
}
